<template>
  <!-- 物料管理 -->
  <div>
    <avue-crud
      :option="tableOption"
      :data="tableData"
      :page.sync="tablePage"
      :cell-style="cellStyle"
      @on-load="loadData"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAddDialog()">
          选择物料
        </el-button>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="importFile()">
          批量导入
        </el-button>
        <el-button type="danger" plain icon="el-icon-delete" size="small" @click="delSelected()">
          删除
        </el-button>
      </template>
      <template slot="outboundNum" slot-scope="{ row }">
        <el-input v-model.number="row.outboundNum" maxlength="10"></el-input>
      </template>
      <template slot="conversionNum" slot-scope="{ row }">
        {{ (row.conversionNum = convertGoodsUnit(row, 'outboundNum')) }}
      </template>
      <template slot="outboundPrice" slot-scope="{ row }">
        {{ tool.money_format_allowvoid((row.outboundPrice = row.outboundNum * row.price || '')) }}
      </template>
      <template slot="remark" slot-scope="{ row }">
        <el-input v-model="row.remark" maxlength="200"></el-input>
      </template>
    </avue-crud>
    <div class="sum-tips">
      <div style="color: red;">小数位数：单价2位，金额2位，超出部分将四舍五入</div>
      <div>
        合计出库数量：<span style="color: blue;">{{ sumNum }}</span
        >&nbsp;&nbsp; 合计金额：<span style="color: red;">{{
          tool.money_format_allowvoid(sumMoney)
        }}</span>
      </div>
    </div>
    <!-- 物料选择的弹框 -->
    <el-dialog
      title="选择物料"
      width="80%"
      :visible.sync="isAddDialogShow"
      :before-close="beforeCloseAddDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <GoodsList
        v-if="isAddDialogShow"
        :projectId="projectId"
        :warehouseId="warehouseId"
        :needStoreInfo="true"
        @update="addGoodsList"
        @close="closeAddDialog"
      ></GoodsList>
    </el-dialog>
    <!-- 批量导入的弹框 -->
    <el-dialog
      title="批量导入"
      append-to-body
      :visible.sync="isImportDialogShow"
      :close-on-click-modal="false"
      width="600px"
      accept="vnd.ms-excel"
    >
      <el-form label-width="120px">
        <el-form-item label="数据上传：">
          <el-upload
            class="upload-demo"
            drag
            :file-list="importFileList"
            :http-request="addImportFile"
            :before-remove="delImportFile"
            :multiple="false"
            accept=".xls,.xlsx"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">请上传 .xls,.xlsx 标准格式文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="模板下载：">
          <el-row>
            <el-col>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="exportDemoExcel"
              >
                下载模板
              </el-button>
              <el-radio-group
                v-model="exportExcelType"
                style="margin-left: 10px; dislay: flex; align-items: center;"
              >
                <el-radio :label="1">只导出表头模板</el-radio>
                <el-radio :label="2">导出含物料信息的模板</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <div style="float: right;">
            <el-button type="primary" size="small" @click="saveImport">确定</el-button>
            <el-button size="small" @click="isImportDialogShow = false">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import GoodsList from '../components/goods-list';
import { getToken } from '@/util/auth';
import { uploadExcelMaterialApi } from '@/api/warehouse/out';
import mixin from '../mixin';

export default {
  name: 'GoodsManagement',
  mixins: [mixin],
  components: {
    GoodsList,
  },
  props: {
    // 项目id
    projectId: {
      type: String,
      default: '',
    },
    // 仓库id
    warehouseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 添加弹框是否显示着
      isAddDialogShow: false,
      // 批量导入弹框是否显示着
      isImportDialogShow: false,
      // 导出的模板类型
      exportExcelType: 1,
      // 导入的文件列表
      importFileList: [],
      // 合计数量
      sumNum: 0,
      // 合计金额
      sumMoney: 0,
      // 延迟计算合计数据的计时器
      sumTimer: -1,
      // 总的列表数据
      listData: [],
      // 单页表格数据
      tableData: [],
      // 选中的项
      selectedList: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        selection: true,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '物料类型',
            prop: 'typeName',
          },
          {
            label: '物料编码',
            prop: 'code',
          },
          {
            label: '物料名称',
            prop: 'name',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: 'measuringUnitName',
          },
          {
            label: '单价',
            prop: 'price',
            align: 'right',
          },
          {
            label: '本仓库余量',
            prop: 'stockNum',
          },
          {
            label: '本次出库数量*',
            prop: 'outboundNum',
            slot: true,
          },
          {
            label: '换算数量',
            prop: 'conversionNum',
            slot: true,
          },
          {
            label: '本次出库金额',
            prop: 'outboundPrice',
            align: 'right',
            slot: true,
          },
          {
            label: '备注',
            prop: 'remark',
            slot: true,
          },
        ],
      },
    };
  },
  watch: {
    listData: {
      deep: true,
      handler(newVal) {
        clearTimeout(this.sumTimer);
        this.sumTimer = setTimeout(this.updateSumData, 300);
      },
    },
    projectId(val) {
      this.resetGoodsList();
    },
    warehouseId(val) {
      this.resetGoodsList();
    },
  },
  methods: {
    /* 表格可编辑列的样式 */
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let labels = ['本次出库数量*', '备注'];
      // 如果出库数量大于存库，则将单元格背景置红
      if (column.label == labels[0] && row.outboundNum && row.outboundNum > row.stockNum) {
        return {
          backgroundColor: 'red',
        };
      } else if (labels.includes(column.label)) {
        return {
          backgroundColor: '#fffde5',
        };
      }
    },
    /* 清空物料列表 */
    resetGoodsList() {
      this.listData = [];
      this.tableData = [];
      this.tablePage.total = 0;
      this.tablePage.currentPage = 1;
    },
    /* 选择物料 */
    openAddDialog() {
      this.isAddDialogShow = true;
    },
    /* 物料选择列表回传的数据 */
    addGoodsList(goodsList) {
      this.listData = this.listData.concat(goodsList);
      this.updateGoodsList();
    },
    /* 关闭物料选择列表的弹框 */
    closeAddDialog(type) {
      if (type == 'cancel') {
        this.beforeCloseAddDialog();
      } else {
        this.isAddDialogShow = false;
      }
    },
    /* 批量导入 */
    importFile() {
      this.isImportDialogShow = true;
    },
    /* 模板下载 */
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let apiStr = '';
        if (this.exportExcelType == 1) {
          apiStr = '/api/v4ward/warehouse/outbound/export-template';
        } else {
          apiStr = '/api/v4ward/warehouse/outbound/export-material-template';
        }
        window.open(
          `${apiStr}?${this.website.tokenHeader}=${getToken()}&projectId=${this.projectId}`
        );
      });
    },
    /* 上传模板 */
    addImportFile(file) {
      // 只保留一个即可
      this.importFileList[0] = file;
    },
    /* 删除模板 */
    delImportFile() {
      this.importFileList = [];
    },
    /* 保存模板 */
    saveImport() {
      if (this.importFileList.length == 0) {
        this.$message.warning('请先导入模板！');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在解析...',
        spinner: 'el-icon-loading',
      });
      let fd = new FormData();
      fd.append('file', this.importFileList[0].file);
      fd.append('projectId', this.projectId);
      fd.append('warehouseId', this.warehouseId);
      uploadExcelMaterialApi(fd)
        .then((res) => {
          let ret = res.data;
          if (ret.code == 200) {
            let arr = ret.data || [];
            arr.forEach((item) => {
              // 后端要求回传时补consumableId，并且物料去重也要用consumableId字段
              item.consumableId = item.id;
            });
            this.listData = this.listData.concat(arr);
            this.updateGoodsList();
            loading.close();
            this.$message.success('导入成功！');
            this.isImportDialogShow = false;
            this.importFileList = [];
          } else {
            loading.close();
            this.importFileList = [];
            this.$message.error(ret.msg);
          }
        })
        .catch(() => {
          loading.close();
          this.importFileList = [];
        });
    },
    /* 删除选中 */
    delSelected() {
      if (this.selectedList.length == 0) {
        this.$message.warning('请先勾选数据!');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // 从总列表里剔除待删除的选项
        this.selectedList.forEach((item) => {
          this.listData.splice(this.listData.indexOf(item), 1);
        });
        this.$message.success('操作成功!');
        this.updateGoodsList();
      });
    },
    /* 勾选项发生变化 */
    selectionChange(val) {
      this.selectedList = val;
    },
    /* 刷新总数据 */
    updateGoodsList() {
      // 根据 consumableId 对物料进行去重处理
      this.listData = this.deduplicateArray(this.listData, 'consumableId');
      // 重置下后端返回的数据里的部分字段，否则页面会显示出错
      this.listData.forEach((item) => {
        if (item.stockPrice <= 0) {
          item.stockPrice = '';
        }
        // 初始显示时使用 stockPrice ，但是上传时需要使用 price ，所以这里转换下
        item.price = item.stockPrice;
        if (item.outboundNum <= 0) {
          item.outboundNum = '';
        }
        if (item.outboundPrice <= 0) {
          item.outboundPrice = '';
        }
      });
      this.tablePage.total = this.listData.length;
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 加载单页表格数据 */
    loadData(page) {
      page = page || this.tablePage;
      let index = (this.tablePage.currentPage - 1) * this.tablePage.pageSize;
      this.tableData = this.listData.slice(index, index + this.tablePage.pageSize);
    },
    /* 计算汇总 */
    updateSumData() {
      let sumNum = 0;
      let sumMoney = 0;
      this.listData.forEach((item) => {
        sumNum += parseFloat(item.outboundNum || 0);
        sumMoney += parseFloat(item.outboundPrice || 0);
      });
      this.sumNum = sumNum;
      this.sumMoney = sumMoney;
      this.$emit('update', { list: this.listData, sumNum: this.sumNum, sumMoney: this.sumMoney });
    },
    /* 根据数组里每项元素的指定字段来对数组去重 */
    deduplicateArray(arr, field) {
      let map = new Map();
      let result = [];
      for (let item of arr) {
        let key = item[field];
        if (!map.has(key)) {
          map.set(key, item);
          result.push(item);
        }
      }
      return result;
    },
    /* 关闭弹框的确认框 */
    beforeCloseAddDialog(done) {
      this.$confirm(' 是否关闭继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (typeof done == 'function') {
            done();
          } else {
            this.isAddDialogShow = false;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.sum-tips {
  display: flex;
  justify-content: space-between;
}

/* 批量导入的下载模板行的样式 */
::v-deep .el-col {
  display: flex;
}

/* 批量导入的下载模板行的样式 */
::v-deep .el-radio-group {
  display: flex;
  align-items: center;
}
</style>
